import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';
import { resolve, resolveAll } from '../helpers/LinkMapper';
import Reservation from '../records/Reservation';
import UserStore from '../stores/UserStore';
import { ReservationSalesFlowType } from '../constants/AppConstants';


const ReservationsService = {
    getBaseUrl() {
        return `/reservations/reservation/`;
    },

    async getReservationsAvailability({ journeys, passengers }) {
        /*
            {
                "salesFlowType": "SALES",
                "passengers": [
                    {
                        "id": "passenger_1",
                        "statusCode": "000"
                    }
                ],
                "journeys": [
                    {
                        "id": "journey_1",
                        "direction": "OUTBOUND",
                        "journeyConditions": {
                            "journeyOD": {
                                "journeyOrigin": "3526",
                                "journeyDestination": "3087"
                            }
                        },
                        "legs": [
                            {
                                "id": "segment_1",
                                "boardLocation": "CMN",
                                "alightLocation": "PAD",
                                "rsid": "GW642000",
                                "serviceOriginDate": "2025-04-16"
                            }
                        ],
                        "bundles": [
                            {
                                "id": "bundle_1",
                                "products": [
                                    {
                                        "ticketTypeCode": "SDS",
                                        "routeCode": "00000",
                                        "sequenceNumber": 1
                                    },
                                    {
                                        "ticketTypeCode": "SOR",
                                        "routeCode": "00000",
                                        "sequenceNumber": 2
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        */
        try {
            const payload = {
                salesFlowType: ReservationSalesFlowType.SALES,
                journeys,
                passengers,
            };
            const response = await AuthenticatedAPIClient.post(`/reservations/availability?includeLegAvailability=true`, payload);
            return response;
        } catch (error) {
            throw error;
        }
    },

    async createReservation(reservation) {
        try {
            /*
                {
                "passengers": [
                    {
                    "statusCode": "000",
                    "attributes": [
                        "NONE",
                        "WIND",
                        "AIRL",
                        "QUIE",
                        "NRWC",
                        "POWE",
                        "LUGG"
                    ]
                    }
                ],
                "outwardJourney": {
                    "origin": {
                    "nlc": "6836",
                    "name": "Chelmsford"
                    },
                    "destination": {
                    "nlc": "8487",
                    "name": "Leeds"
                    },
                    "ticketTypeCode": "OAS",
                    "routeCode": "00430",
                    "reserve": true,
                    "legs": [
                    {
                        "date": "2025-04-02",
                        "retailServiceId": "LE519500",
                        "origin": {
                        "nlc": "6836",
                        "name": "Chelmsford"
                        },
                        "destination": {
                        "nlc": "6965",
                        "name": "London Liverpool Street"
                        },
                        "departure": "2025-04-02T16:26:00",
                        "arrival": "2025-04-02T17:02:00",
                        "reservable": "No",
                        "operator": "LE",
                        "mode": "Train"
                    },
                    {
                        "origin": {
                        "nlc": "6965",
                        "name": "London Liverpool Street"
                        },
                        "destination": {
                        "nlc": "6121",
                        "name": "London Kings Cross"
                        },
                        "operator": "LT",
                        "mode": "Metro"
                    },
                    {
                        "date": "2025-04-02",
                        "retailServiceId": "GR258000",
                        "origin": {
                        "nlc": "6121",
                        "name": "London Kings Cross"
                        },
                        "destination": {
                        "nlc": "8487",
                        "name": "Leeds"
                        },
                        "departure": "2025-04-02T17:48:00",
                        "arrival": "2025-04-02T20:17:00",
                        "reservable": "Compulsory",
                        "operator": "GR",
                        "mode": "Train"
                    }
                    ]
                },
                "returnJourney": {
                    "origin": {
                    "nlc": "8487",
                    "name": "Leeds"
                    },
                    "destination": {
                    "nlc": "6836",
                    "name": "Chelmsford"
                    },
                    "ticketTypeCode": "OET",
                    "routeCode": "00430",
                    "reserve": true,
                    "legs": [
                    {
                        "date": "2025-04-03",
                        "retailServiceId": "TP530000",
                        "origin": {
                        "nlc": "8487",
                        "name": "Leeds"
                        },
                        "destination": {
                        "nlc": "8263",
                        "name": "York"
                        },
                        "departure": "2025-04-03T02:34:00",
                        "arrival": "2025-04-03T03:13:00",
                        "reservable": "Possible",
                        "operator": "TP",
                        "mode": "Train"
                    },
                    {
                        "date": "2025-04-03",
                        "retailServiceId": "GR300000",
                        "origin": {
                        "nlc": "8263",
                        "name": "York"
                        },
                        "destination": {
                        "nlc": "6121",
                        "name": "London Kings Cross"
                        },
                        "departure": "2025-04-03T04:40:00",
                        "arrival": "2025-04-03T07:00:00",
                        "reservable": "Compulsory",
                        "operator": "GR",
                        "mode": "Train"
                    },
                    {
                        "origin": {
                        "nlc": "6121",
                        "name": "London Kings Cross"
                        },
                        "destination": {
                        "nlc": "6965",
                        "name": "London Liverpool Street"
                        },
                        "operator": "LT",
                        "mode": "Metro"
                    },
                    {
                        "date": "2025-04-03",
                        "retailServiceId": "LE516300",
                        "origin": {
                        "nlc": "6965",
                        "name": "London Liverpool Street"
                        },
                        "destination": {
                        "nlc": "6836",
                        "name": "Chelmsford"
                        },
                        "departure": "2025-04-03T07:46:00",
                        "arrival": "2025-04-03T08:21:00",
                        "reservable": "No",
                        "operator": "LE",
                        "mode": "Train"
                    }
                    ]
                },
                "bikes": 1
                }
            */

            const user = UserStore.getCurrent();

            const payload = reservation.formatForAPI(reservation);

            const response = await AuthenticatedAPIClient.post(`${this.getBaseUrl()}customer/${user.id}`, payload);
            return resolve(response).as(Reservation);
        } catch (error) {
            console.warn('Create reservation error', error);
            throw error;
        }
    },

    async amendReservation(reservation) {
        try {
            const user = UserStore.getCurrent();

            const payload = reservation.formatForAPI(reservation, user.id);

            const response = await AuthenticatedAPIClient.put(
                `${this.getBaseUrl()}${reservation.reservationId}`,
                payload,
            );
            return resolve(response.result).as(Reservation);
        } catch (error) {
            throw error;
        }
    },

    async cancelReservation(reservationId) {
        try {
            const response = await AuthenticatedAPIClient.put(`${this.getBaseUrl()}${reservationId}`);
            const reservation = resolve(response).as(Reservation);
            return reservation;
        } catch (error) {
            throw error;
        }
    },

    async getReservations(page = 1) {
        try {
            const user = UserStore.getCurrent();
            const response = await AuthenticatedAPIClient.get(`${this.getBaseUrl()}customer/${user.id}?page=${page}`);

            if (response.result) {
                try {
                    const resolvedReservations = resolveAll(response.result).as(Reservation);
                    return {
                        reservations: resolvedReservations,
                        pagination: response.pagination,
                    };
                } catch (error) {
                    console.warn('error retrieving reservations', error);
               }
            }
            return null;
        } catch (error) {
            throw error;
        }
    },


};

export default ReservationsService;



// WEBPACK FOOTER //
// ./src/services/ReservationsService.js